// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const CountryOut = zod.object({
  "code": zod.string(),
  "name": zod.string()
});

export type CountryOut = zod.input<typeof CountryOut>;
export type CountryOutOutput = zod.output<typeof CountryOut>;
